import { openCustomerFeatureOverlay } from '@/utils/customerFeatureOverlays';

function isOverlayNavItem(item) {
  return item?.openAs === 'overlay' || (item?.itemKind === 'link' && !item?.route);
}

/**
 * Navigate or open a customer sidebar nav item (page route or registered overlay).
 */
/**
 * @returns {boolean} false when an overlay link could not be opened (unregistered overlay)
 */
export function navigateCustomerNavItem(router, store, item) {
  if (!item || item.itemKind !== 'link') return true;

  if (isOverlayNavItem(item)) {
    if (item.locked) {
      router.push({ name: 'gatedFeature', query: { catalogKey: item.catalogKey } });
      return true;
    }
    return openCustomerFeatureOverlay(store, item.catalogKey);
  }

  if (item.locked) {
    router.push({ name: 'gatedFeature', query: { route: item.route } });
    return true;
  }

  if (item.route) {
    router.push(item.route);
  }
  return true;
}
